import * as angular from "angular";
import newsletters from './newsletters/newsletters.module';
import newsletterDistributions from './newsletter-distributions/newsletter-distributions.module';
import newsfeeds from './newsfeeds/newsfeeds.module';
import './articles/articles.module';
import './wysiwyg/tinymce/tinymce-wrapper.module';


import newsletterRoutes from './newsletters/newsletters.route.config';
import newsletterDistributionRoutes from './newsletter-distributions/newsletter-distributions.route.config';
import newsfeedRoutes from './newsfeeds/newsfeeds.route.config';
import defaultRoutes from './default.route.config';

export default angular
    .module('mw.outputs', [newsletters, newsletterDistributions, newsfeeds])
    .config(newsletterRoutes)
    .config(newsletterDistributionRoutes)
    .config(newsfeedRoutes)
    .config(defaultRoutes)
    .name;



/** WEBPACK FOOTER **
 ** ./apps-ts/outputs/src/app/app.ts
 **/